import * as React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
} from '@mui/material';
import { main_button, sec_button } from '../../app/components/Styles';

export const CANCELLATION_REASONS = [
    'Customer Request',
    'Partner Request',
    'Sold Out',
    'Duplicate Order',
    'ConfirmIt Cancellation',
    'Delivery Failed',
    'Warehouse Issue',
    'Other',
];

export const CancelOrderModal = ({ open, onClose, onConfirm, isLoading }) => {
    const [reason, setReason] = React.useState('');
    const [error, setError] = React.useState('');

    React.useEffect(() => {
        if (open) {
            setReason('');
            setError('');
        }
    }, [open]);

    const handleConfirm = () => {
        if (!reason) {
            setError('Please select a cancellation reason');
            return;
        }
        onConfirm(reason);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Cancel Order</DialogTitle>
            <DialogContent>
                <FormControl fullWidth margin="normal" error={Boolean(error)}>
                    <InputLabel id="cancel-reason-label">Cancellation reason</InputLabel>
                    <Select
                        labelId="cancel-reason-label"
                        label="Cancellation reason"
                        value={reason}
                        onChange={(e) => {
                            setReason(e.target.value);
                            setError('');
                        }}
                    >
                        {CANCELLATION_REASONS.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                    {error && <FormHelperText>{error}</FormHelperText>}
                </FormControl>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onClose} sx={sec_button} disabled={isLoading}>
                    Back
                </Button>
                <Button onClick={handleConfirm} sx={main_button} disabled={isLoading}>
                    {isLoading ? 'Cancelling...' : 'Confirm Cancel'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
